<template>
  <div
    ref="recaptchaContainer"
    class="recaptcha-v3-container"
  />
</template>

<script>
import { loadRecaptchaScript } from '@/libs/recaptcha'

export default {
  name: 'RecaptchaInvisible',
  props: {
    sitekey: {
      type: [String, Function],
      default: () => process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
    },
    action: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoaded: false,
      currentToken: '',
    }
  },
  computed: {
    effectiveSiteKey() {
      if (typeof this.sitekey === 'function') {
        return this.sitekey()
      }
      return this.sitekey
    },
  },
  mounted() {
    this.initRecaptcha()
  },
  methods: {
    async initRecaptcha() {
      try {
        await loadRecaptchaScript(this.effectiveSiteKey)
        if (window.grecaptcha && window.grecaptcha.enterprise) {
          window.grecaptcha.enterprise.ready(() => {
            this.isLoaded = true
            this.$emit('ready')
          })
        }
      } catch (error) {
        this.$emit('error', error)
      }
    },
    async execute(actionName) {
      const action = actionName || this.action
      if (!action) {
        const error = new Error('[RecaptchaInvisible] Context "action" wajib disertakan saat eksekusi reCAPTCHA.')
        this.currentToken = ''
        this.$emit('error', error)
        throw error
      }

      if (!this.effectiveSiteKey) {
        const error = new Error('[RecaptchaInvisible] Site key reCAPTCHA tidak ditemukan. Pastikan SITE_KEY telah disetel.')
        this.currentToken = ''
        this.$emit('error', error)
        throw error
      }

      try {
        await loadRecaptchaScript(this.effectiveSiteKey)
        if (!window.grecaptcha || !window.grecaptcha.enterprise
          || typeof window.grecaptcha.enterprise.execute !== 'function') {
          throw new Error('Google reCAPTCHA gagal dimuat atau tidak tersedia.')
        }

        return await new Promise((resolve, reject) => {
          window.grecaptcha.enterprise.ready(async () => {
            try {
              const token = await window.grecaptcha.enterprise.execute(this.effectiveSiteKey, { action })
              if (!token) {
                throw new Error('Gagal memperoleh token verifikasi reCAPTCHA.')
              }
              this.currentToken = token
              this.$emit('verify', token)
              resolve(token)
            } catch (err) {
              reject(err)
            }
          })
        })
      } catch (error) {
        this.currentToken = ''
        this.$emit('error', error)
        throw error
      }
    },
    reset() {
      this.currentToken = ''
    },
    getResponse() {
      return this.currentToken
    },
  },
}
</script>
